(function () {
  'use strict';

  /* ========================================================
     ORGANIZAZ MOTION SYSTEM
     ======================================================== */

  const REDUCED_MOTION = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const MOBILE = window.matchMedia(
    '(max-width: 749px)'
  );


  /* ========================================================
     CONFIGURAÇÃO
     ======================================================== */

  const CONFIG = {
    threshold: 0.12,
    rootMargin: '0px 0px -7% 0px',
    staggerDesktop: 85,
    staggerMobile: 60,
    maxAutomaticItems: 8
  };


  /* ========================================================
     HELPERS
     ======================================================== */

  function isInsideSlider(element) {
    return Boolean(
      element.closest(
        '[class*="slider"],' +
        '[class*="carousel"],' +
        '[class*="swiper"],' +
        '[class*="track"],' +
        '[data-slider]'
      )
    );
  }


  function alreadyPrepared(element) {
    return element.hasAttribute('data-oz-reveal');
  }


  function setReveal(element, type, delay, speed) {

    if (!element) return;
    if (alreadyPrepared(element)) return;
    if (element.closest('[data-oz-motion="off"]')) return;
    if (isInsideSlider(element)) return;

    element.setAttribute(
      'data-oz-reveal',
      type || 'up'
    );

    if (typeof delay === 'number' && delay > 0) {
      element.style.setProperty(
        '--oz-motion-delay',
        delay + 'ms'
      );
    }

    if (speed) {
      element.setAttribute(
        'data-oz-speed',
        speed
      );
    }

  }


  /* ========================================================
     CABEÇALHO INTERNO DA SECTION
     eyebrow → título → texto
     ======================================================== */

  function prepareSectionHeader(section) {

    const eyebrow =
      section.querySelector(
        '[class*="eyebrow"],' +
        '[class*="kicker"],' +
        '[class*="label"]'
      );

    const title =
      section.querySelector('h1,h2');

    let intro = null;

    if (title) {

      const headerParent =
        title.closest(
          '[class*="head"],' +
          '[class*="header"],' +
          '[class*="intro"]'
        );

      if (headerParent) {
        intro = headerParent.querySelector('p');
      }

    }

    if (!intro) {
      intro = section.querySelector('p');
    }


    if (eyebrow) {
      setReveal(
        eyebrow,
        'up',
        0,
        'fast'
      );
    }


    if (title) {
      setReveal(
        title,
        'up',
        55
      );
    }


    if (
      intro &&
      intro !== title &&
      !intro.closest('form')
    ) {

      setReveal(
        intro,
        'up',
        115
      );

    }

  }


  /* ========================================================
     IMAGENS EDITORIAIS
     Apenas imagens grandes.
     ======================================================== */

  function prepareImages(section) {

    const images =
      Array.from(
        section.querySelectorAll('img')
      );

    let applied = 0;


    images.forEach(function (image) {

      if (applied >= 3) return;

      if (isInsideSlider(image)) return;

      const rect =
        image.getBoundingClientRect();

      const probableLargeImage =
        rect.width >= 280 ||
        image.width >= 280 ||
        image.naturalWidth >= 700;


      if (!probableLargeImage) return;


      let target =
        image.closest(
          'figure,' +
          'picture,' +
          '[class*="media"],' +
          '[class*="visual"],' +
          '[class*="image-wrap"]'
        );


      if (!target) {
        target = image;
      }


      if (alreadyPrepared(target)) return;


      setReveal(
        target,
        'image',
        applied * 70,
        'slow'
      );

      applied++;

    });

  }


  /* ========================================================
     GRUPOS / CARDS
     Procura estruturas repetidas e cria stagger.
     ======================================================== */

  function prepareGroups(section) {

    const possibleGroups =
      section.querySelectorAll(
        '[class*="grid"],' +
        '[class*="cards"],' +
        '[class*="items"],' +
        '[class*="products"],' +
        '[class*="columns"],' +
        '[class*="list"]'
      );


    possibleGroups.forEach(function (group) {

      if (group.closest('form')) return;
      if (isInsideSlider(group)) return;

      const className =
        String(group.className || '').toLowerCase();


      if (
        className.includes('slider') ||
        className.includes('carousel') ||
        className.includes('track') ||
        className.includes('swiper')
      ) {
        return;
      }


      const children =
        Array.from(group.children)
          .filter(function (child) {

            const tag =
              child.tagName.toLowerCase();

            return (
              tag === 'div' ||
              tag === 'article' ||
              tag === 'li' ||
              tag === 'a'
            );

          });


      if (
        children.length < 2 ||
        children.length > CONFIG.maxAutomaticItems
      ) {
        return;
      }


      const stagger =
        MOBILE.matches
          ? CONFIG.staggerMobile
          : CONFIG.staggerDesktop;


      children.forEach(function (child, index) {

        if (alreadyPrepared(child)) return;
        if (isInsideSlider(child)) return;

        setReveal(
          child,
          'up',
          index * stagger
        );

      });

    });

  }


  /* ========================================================
     DUAS COLUNAS
     Cria leve contraste direcional.
     ======================================================== */

  function prepareSplitLayouts(section) {

    const grids =
      Array.from(
        section.querySelectorAll(
          '[class*="grid"],' +
          '[class*="layout"],' +
          '[class*="split"]'
        )
      );


    grids.forEach(function (grid) {

      if (isInsideSlider(grid)) return;

      const children =
        Array.from(grid.children);


      if (children.length !== 2) return;


      const first =
        children[0];

      const second =
        children[1];


      if (
        first.closest('form') ||
        second.closest('form')
      ) {
        return;
      }


      if (!alreadyPrepared(first)) {

        setReveal(
          first,
          MOBILE.matches ? 'up' : 'left',
          0,
          'slow'
        );

      }


      if (!alreadyPrepared(second)) {

        setReveal(
          second,
          MOBILE.matches ? 'up' : 'right',
          MOBILE.matches ? 70 : 90,
          'slow'
        );

      }

    });

  }


  /* ========================================================
     PREPARA UMA SECTION
     ======================================================== */

  function prepareSection(section) {

    if (!section) return;

    if (
      section.dataset.ozMotionPrepared === 'true'
    ) {
      return;
    }


    if (
      section.dataset.ozMotion === 'off'
    ) {
      return;
    }


    section.dataset.ozMotionPrepared =
      'true';


    prepareSectionHeader(section);

    prepareSplitLayouts(section);

    prepareGroups(section);

    prepareImages(section);

  }


  /* ========================================================
     ENCONTRA SEÇÕES ORGANIZAZ
     ======================================================== */

  function prepareAllSections(root) {

    const context =
      root || document;


    const sections =
      context.querySelectorAll
        ? context.querySelectorAll(
            '#MainContent section[id^="oz-"],' +
            'main section[id^="oz-"]'
          )
        : [];


    sections.forEach(
      prepareSection
    );

  }


  /* ========================================================
     INTERSECTION OBSERVER
     ======================================================== */

  let observer = null;


  function createObserver() {

    if (REDUCED_MOTION.matches) {

      document
        .querySelectorAll('[data-oz-reveal]')
        .forEach(function (element) {
          element.classList.add('oz-in-view');
        });

      return;
    }


    observer =
      new IntersectionObserver(
        function (entries) {

          entries.forEach(
            function (entry) {

              if (!entry.isIntersecting) {
                return;
              }


              const element =
                entry.target;


              element.classList.add(
                'oz-in-view'
              );


              if (
                element.dataset.ozOnce !==
                'false'
              ) {

                observer.unobserve(
                  element
                );

              }

            }
          );

        },
        {
          threshold:
            CONFIG.threshold,

          rootMargin:
            CONFIG.rootMargin
        }
      );

  }


  /* ========================================================
     OBSERVA ELEMENTOS NOVOS
     ======================================================== */

  function observePreparedElements(root) {

    const context =
      root || document;


    const elements =
      context.querySelectorAll
        ? context.querySelectorAll(
            '[data-oz-reveal]:not([data-oz-observed])'
          )
        : [];


    elements.forEach(
      function (element) {

        element.setAttribute(
          'data-oz-observed',
          'true'
        );


        if (
          REDUCED_MOTION.matches
        ) {

          element.classList.add(
            'oz-in-view'
          );

          return;
        }


        if (observer) {
          observer.observe(element);
        }

      }
    );

  }


  /* ========================================================
     ELEMENTOS MANUAIS
     ======================================================== */

  function prepareManualDelays() {

    document
      .querySelectorAll(
        '[data-oz-delay]'
      )
      .forEach(function (element) {

        const delay =
          parseInt(
            element.dataset.ozDelay,
            10
          );


        if (!Number.isNaN(delay)) {

          element.style.setProperty(
            '--oz-motion-delay',
            delay + 'ms'
          );

        }

      });

  }


  /* ========================================================
     HERO / PRIMEIRA SECTION
     Pode entrar logo no carregamento.
     ======================================================== */

  function revealAboveFold() {

    window.requestAnimationFrame(
      function () {

        document
          .querySelectorAll(
            '[data-oz-reveal]'
          )
          .forEach(function (element) {

            const rect =
              element.getBoundingClientRect();


            if (
              rect.top <
                window.innerHeight * .92 &&
              rect.bottom > 0
            ) {

              element.classList.add(
                'oz-in-view'
              );


              if (observer) {
                observer.unobserve(
                  element
                );
              }

            }

          });

      }
    );

  }


  /* ========================================================
     SHOPIFY THEME EDITOR
     ======================================================== */

  function bindShopifyEditor() {

    document.addEventListener(
      'shopify:section:load',
      function (event) {

        const section =
          event.target.querySelector(
            'section[id^="oz-"]'
          );


        if (section) {

          prepareSection(section);

          observePreparedElements(
            event.target
          );

        }

      }
    );

  }


  /* ========================================================
     MUTATION OBSERVER
     Para conteúdo carregado depois.
     ======================================================== */

  function createMutationObserver() {

    const mutationObserver =
      new MutationObserver(
        function (mutations) {

          mutations.forEach(
            function (mutation) {

              mutation.addedNodes.forEach(
                function (node) {

                  if (
                    node.nodeType !== 1
                  ) {
                    return;
                  }


                  if (
                    node.matches &&
                    node.matches(
                      'section[id^="oz-"]'
                    )
                  ) {

                    prepareSection(node);

                  }


                  if (
                    node.querySelectorAll
                  ) {

                    prepareAllSections(
                      node
                    );

                    observePreparedElements(
                      node
                    );

                  }

                }
              );

            }
          );

        }
      );


    mutationObserver.observe(
      document.body,
      {
        childList:true,
        subtree:true
      }
    );

  }


  /* ========================================================
     INIT
     ======================================================== */

  function init() {

    prepareAllSections();

    prepareManualDelays();

    createObserver();

    observePreparedElements();

    document.documentElement
      .classList.add(
        'oz-motion-ready'
      );


    revealAboveFold();

    bindShopifyEditor();

    createMutationObserver();

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();